<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-card elevation="6">
        <div class="pa-4">
          <div class="grid_flex">
            <div>{{ header_list.product_name }}</div>
            <div class="d_flex">
              <div class="mr-4">จำนวนรวม</div>
              <div>{{ total_count }}</div>
              <div class="ml-4">{{ header_list.unit_name }}</div>
            </div>
          </div>
        </div>
        <div class="pa-2">
          <v-card-title>
            <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
          </v-card-title>
          <v-data-table :headers="headers" :items="data_list" :footer-props="footer_Props" :search="search" mobile-breakpoint="0">
            <template slot="item" slot-scope="dataDetail">
              <tr>
                <td>{{ dataDetail.item.lot_no }}</td>
                <td>{{ diffDateTH(dataDetail.item.date_expired) }}</td>
                <td>{{ format_number(dataDetail.item.quantity) }}</td>
                <td>{{ item_unit = header_list.unit_name }}</td>
                <td>{{ dataDetail.item.supplier_name }}</td>
                <td>
                  <div v-if="dataDetail.item.status === 0" style="color: #2d78ff">ส่งคืนแล้ว</div>
                  <div v-else-if="dataDetail.item.status === 1" style="color: #8cc63e">เสร็จสิ้น</div>
                </td>
                <td class="pa-4">
                  <div @click="getData(dataDetail.item.doc_no)">
                    <a><u>{{ dataDetail.item.doc_no }}</u></a>
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";
import {formatNumber} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Reduce_debt_details_success",
  data() {
    return {
      loading_page: false,
      search: null,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      headers: [
        {
          text: 'ล็อตสินค้า',
          value: 'lot_no',
          fixed: true,
          width: '150px',
        },
        {
          text: 'วันหมดอายุ',
          value: 'date_expired',
          fixed: true,
          width: '150px',
        },
        {
          text: 'จำนวนคงเหลือ',
          value: 'quantity',
          fixed: true,
          width: '170px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit_name',
          sortable: false,
          fixed: true,
          width: '150px',
        },
        {
          text: 'ซัพพลายเออร์',
          value: 'supplier_name',
          fixed: true,
          width: '300px',
        },
        {
          text: 'สถานะ',
          value: 'status',
          fixed: true,
          width: '120px',
        },
        {
          text: 'เลขที่เอกสารส่งคืนสินค้า',
          value: 'doc_no',
          fixed: true,
          width: '250px',
        },
      ],
      data_list: [],
      header_list: [],
    }
  },
  methods: {
    format_number: function(value) {
      return formatNumber(value)
    },
    diffDateTH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0])+ 543
      return day+'/'+month+'/'+year
    },
    get_data() {
      this.loading_page = true
      HTTP.post('/inventory/reducts/reductget', {
        product_id: this.$route.params.id,
        type: 1,
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.header_list = res.data.object.head
          this.data_list = res.data.object.list
        }
      })
    },
    getData(id) {
      this.$router.push('/stock/document/documentreducedetails/' + id)
    }
  },
  computed: {
    total_count() {
      let data_list = this.data_list
      const result = data_list.reduce((sum,number) => {
        let total_all = number.quantity
        if (total_all < 0) {
          return sum + 0
        }
        else {
          return sum + total_all
        }
      }, 0)
      return result
    },
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.grid_flex {
  display: flex;
  justify-content: space-between;
}
.d_flex {
  display: flex;
}
.grid_unit {
  display: grid;
  grid-template-columns: 50% 50%;
}
@media only screen and (max-width: 500px) {
  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
    text-align: center;
  }
  .d_flex {
    display: flex;
    justify-content: center;
  }
}
</style>
